<!-- OpenPatientButton.vue -->
<script setup lang="ts">
    import { DateUtils } from '../../LibMain';
    import { ActionButtonStyle } from '../../lib/Types/Types';
    import ChoiceButton from './ChoiceButton.vue';
    import { ref } from 'vue';
    import MainWindowMessage from "../../components/Communication/MainWindowMessage.vue";  

    const props=defineProps<{
        patientEntityId: number
    }>();

    defineExpose({openPatient});

    const mainWindowMessage = ref<typeof MainWindowMessage>();    

    function openPatient()
    {
        mainWindowMessage.value?.openEmr({patientEid: props.patientEntityId, scheduleDate: DateUtils.getNoTzToday()});
    }
</script>

<template>
    <slot name="button" :funcOpenPatient="openPatient">
        <ChoiceButton 
            :action="ActionButtonStyle.Open"
            title="Open patient in EMR"
            @click="openPatient" />
    </slot>

    <MainWindowMessage ref="mainWindowMessage"/>  
</template>